<template>
	<div class="page">
		<!-- 表格 -->
		<el-table :data="tableData" style="width: 100%">
			<el-table-column prop="operCategoryType.title" label="转移时间">
				<template slot-scope="scope">
					{{$public.FTime(scope.row.operation_info.create.create_time,'YYYY-MM-DD HH:mm:ss')}}
				</template>
			</el-table-column>
			<el-table-column label="转移门店">
				<template slot-scope="scope">
					{{scope.row.srcShopName == null?'--':scope.row.srcShopName}}
				</template>
			</el-table-column>
			<el-table-column prop="transferUserName" label="转移人">
			</el-table-column>
			<el-table-column prop="receiverTime" label="接收时间">
				<template slot-scope="scope">
					{{$public.FTime(scope.row.receiverTime,'YYYY-MM-DD HH:mm:ss')}}
				</template>
			</el-table-column>
			<el-table-column label="接收门店">
				<template slot-scope="scope">
					{{scope.row.descShopName == null?'--':scope.row.descShopName}}
				</template>
			</el-table-column>
			<el-table-column prop="receiverUserName" label="接收人">
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<page :total="page.total" @change="changePage" style="margin-top: 22px;"></page>
	</div>
</template>

<script>
	import page from "@/components/page.vue"
	import {
		petTransferList
	} from "@/api/purchaseApi.js"
	export default {
		components: {
			page
		},
		props: {
			id: {
				type: String,
				default: ''
			},
		},
		data(){
			return{
				page: {
					page: 1,
					pageSize: 14,
					total: 0
				},
				tableData:[],
			}
		},
		mounted(){
			this.getTableData()
		},
		methods: {
			//获取数据
			getTableData(){
				let params = {
					petId:this.id
				}
				petTransferList(params).then((res)=>{
					if(res.code == 0){
						console.log('转移记录',res)
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			//分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
		},
	}
</script>

<style lang="scss" scoped>
	.page {
		min-height: 734px;
		background: #fff;
		margin-top: 12px;
		font-size: 14px;
	}
</style>
